import { render, staticRenderFns } from "./mWorkCard.vue?vue&type=template&id=3bc1c19c&"
import script from "./mWorkCard.vue?vue&type=script&lang=js&"
export * from "./mWorkCard.vue?vue&type=script&lang=js&"
import style0 from "./mWorkCard.vue?vue&type=style&index=0&id=3bc1c19c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports